var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCnote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81388 12.2971V11.7971H9.31388H8.09375V11.7296H9.31388H9.81388V11.2296V10.2129H10.0252V11.2296V11.7296H10.5252H11.7462V11.7971H10.5252H10.0252V12.2971V13.3138H9.81388V12.2971Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5112 4.01172H29.1031C29.4948 4.01161 29.8826 4.0795 30.2444 4.21151C30.6063 4.34351 30.9351 4.53705 31.2121 4.78106C31.4891 5.02508 31.7088 5.31478 31.8587 5.63364C32.0086 5.9525 32.0857 6.29426 32.0857 6.6394V38.9057C32.0857 39.2509 32.0086 39.5926 31.8587 39.9115C31.7088 40.2303 31.4891 40.5201 31.2121 40.7641C30.9351 41.0081 30.6063 41.2016 30.2444 41.3336C29.8826 41.4656 29.4948 41.5335 29.1031 41.5334H3.98169C3.19089 41.5334 2.43249 41.2566 1.87332 40.7638C1.31414 40.271 1 39.6026 1 38.9057V6.6394C1 5.94249 1.31414 5.27413 1.87332 4.78135C2.43249 4.28856 3.19089 4.01172 3.98169 4.01172H7.58456",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40039 1H25.5337V3.13333H7.40039V1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58398 19.0466H12.1707ZM7.58398 23.6145H22.708ZM7.58398 26.3106H19.9894ZM7.58398 29.0067H22.708ZM7.58398 31.7028H19.9894Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58398 19.0466H12.1707M7.58398 23.6145H22.708M7.58398 26.3106H19.9894M7.58398 29.0067H22.708M7.58398 31.7028H19.9894",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnote);
export default __webpack_public_path__ + "static/media/cnote.5654a01ada3b9e075aafa8dca556ce7f.svg";
export { ForwardRef as ReactComponent };